// Type Imports
import { PreferencesState } from "@pulse-ui/types/components/ToolPanel";
import {
  IAccountMetadata,
  IPortfolioMetadata,
} from "@pulse-ui/codegen/generated_ts/org_metadata";

// Reducer Action Enum
export enum REDUCER_ACTION_TYPE {
  UPDATE_ORG_METADATA,
  SET_PORTFOLIO_BY_ID,
  SET_PORTFOLIO_BY_ACCOUNT_ID,
  SET_ACCOUNT_BY_ID,
  SET_ACCOUNT_DROPCOPY_IP_ADDRESSES,
  SET_QUOTE_ASSET,
  SET_VIEW,
  SET_ACCOUNT_USER_ID,
  SET_ACCOUNT_AUTHORIZED_PORTFOLIOS,
  SET_ADMIN_STATUS,
  SET_USER_PREFERENCES,
  SET_SYMBOL,
}

// Reducer Action Type
export type ReducerAction = {
  type: REDUCER_ACTION_TYPE;
  payload?: any;
};

// Context Init State Type
export type ContextStateType = {
  account: {
    dropcopy_ip_addresses: string[];
    user_id: string;
    authorized_portfolios: string[];
    admin: boolean;
  };
  org_metadata: IOrgMetadata;
  user_preferences: {
    quote_asset: string | null;
    interval: string | null;
    start_time: string | null;
  };
  selected_portfolio: IPortfolioMetadata | null;
  selected_account: IAccountMetadata | null;
  selected_quote_asset: string | null;
  selected_view: string | null;
  selected_symbol: string | null;
};

export interface IOrgMetadata {
  org_id: string;
  display_name: string;
  created: string;
  last_modified: string;
  portfolios: IPortfolioMetadata[] | [];
}

export interface UseContextType {
  initState: ContextStateType;
  context_state: ContextStateType;
  update_org_metadata: (
    metadata: IOrgMetadata
  ) => Promise<{ status: number; error: any }>;
  set_portfolio_by_id: (
    id: string | null
  ) => Promise<{ status: number; error: any }>;
  set_portfolio_by_account_id: (
    id: string | null
  ) => Promise<{ status: number; error: any }>;
  set_account_by_id: (
    id: string | null
  ) => Promise<{ status: number; error: any }>;
  set_account_dropcopy_ip_addresses: (
    value: string[]
  ) => Promise<{ status: number; error: any }>;
  set_quote_asset: (
    value: string | null
  ) => Promise<{ status: number; error: any }>;
  set_view: (value: string | null) => Promise<{ status: number; error: any }>;
  set_account_user_id: (
    value: string | null
  ) => Promise<{ status: number; error: any }>;
  set_account_authorized_portfolios: (
    value: string[] | null
  ) => Promise<{ status: number; error: any }>;
  set_admin_status: (value: boolean) => Promise<{ status: number; error: any }>;
  set_user_preferences: (
    preference_key: "all" | "quote_asset" | "interval" | "start_time",
    value: PreferencesState | string | null
  ) => Promise<{ status: number; error: any }>;
  set_symbol: (value: string | null) => Promise<{ status: number; error: any }>;
}
